<template>
  <section>
    <h3>Global noter</h3>

    <div class="globalnotes">
      <p v-if="notes.length === 0">
        Der er ingen globale noter fra den valgte publiceringsdato.
      </p>
      <div
        v-for="(note, noteIndex) in notes"
        :key="noteIndex"
        class="globalnote"
        :class="{'globalnote--inherited': note.inherited}"
      >
        <BaseCheckbox
          v-model="note.selected"
          :label="note.name + getInheritedText(note)"
          :disabled="note.inherited === true"
          @input="$emit('input', note)"
        />
        <div class="globalnote__readmore">
          <font-awesome-icon
            icon="eye"
            @click="onIconClick(note)"
          />
          <div
            class="globalnote__popup-overlay"
            v-if="selectedNote.id === note.id"
            @click="onClosePopup"
          />
          <div
            class="globalnote__popup"
            v-if="selectedNote.id === note.id"
          >
            <p
              class="globalnote__close"
              @click="onClosePopup"
            >
              <font-awesome-icon icon="times" />
            </p>
            <div class="globalnote__popup-inner">
              <DisplayIcon :id="selectedNote.iconID" />
              <div class="globalnote__popup-content">
                <p class="globalnote__title">
                  {{ selectedNote.name }}
                </p>
                <p>{{ selectedNote.description }}</p>
                <p class="globalnote__popup-version">
                  Version {{ selectedNote.versionNumber }} ({{ selectedNote.publishDate | HumanDate }})
                </p>

                <router-link
                  class="globalnote__link"
                  :to="onPopupReadmoreClick(selectedNote)"
                  target="_blank"
                >
                  Se hele noten
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import DisplayIcon from './DisplayIcon.vue';
import BaseCheckbox from './BaseCheckbox.vue';
import GlobalNotesService from '../services/GlobalNotesService';
import HumanDate from '../filters/HumanDate';

export default {
    name: 'GlobalNotesSelector',
    components: { BaseCheckbox, DisplayIcon },
    filters: { HumanDate },
    props: {
        notes: { type: Array, required: true },
        currentDate: { type: String, required: true },
    },
    data() {
        return {
            selectedNote: {},
        };
    },
    methods: {
        getInheritedText(note) {
            return note.inherited ? ' - Nedarvet' : '';
        },
        bindModel(note) {
            if (note.inherited) {
                return {
                    value: note.selected,
                };
            }

            return {
                value: note.selected,
            };
        },
        async onIconClick({ id }) {
            if (id === this.selectedNote.id) {
                this.onClosePopup();
                return;
            }
            try {
                const data = await GlobalNotesService.getSingle(id, this.currentDate);
                this.selectedNote = data;
            } catch (error) {
                //
            }
        },
        onClosePopup() {
            this.selectedNote = {};
        },
        onPopupReadmoreClick(note) {
            return { name: 'global-notes.single', params: { id: note.id }, query: { date: window.moment(this.currentDate).format('YYYY-MM-DD HH:mm') } };
        },
    },
};
</script>

<style lang="scss" scoped>
.globalnotes {
    display: flex;
    flex-wrap: wrap;
}

.globalnote {
    display: flex;
    width: 50%;

    &--inherited {
        /deep/ .base-checkbox__label {
            color: #bbb;
        }
    }

    &__readmore {
        margin-left: 10px;
        position: relative;
        cursor: pointer;
    }

    &__popup {
        position: absolute;
        left: 0;
        background: $content-background;
        padding: 20px;
        width: 300px;
        max-height: 150px;
        overflow: auto;
        z-index: 2;
        box-shadow: 0 0 5px 2px rgba($black,.15);
        cursor: initial;

        &-inner {
            display: flex;
        }

        &-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100vw;
            height: 100vh;
            background-color: rgba(0,0,0,0);
            z-index: 1;
        }

        &-content {
            margin-left: 10px;
        }

        &-version {
            font-style: italic;
            font-size: 12px;
            margin-top: 10px;
        }
    }

    &__close {
        position: absolute;
        top: 5px;
        right: 5px;
        color: $white;
        cursor: pointer;
        color: $brand;
    }
    &__link {
        display: block;
        color: $brand;
        text-decoration: underline;
        margin-top: 10px;
    }
    &__title {
        font-weight: bold;
        margin-bottom: 5px;
    }
}
</style>
